export default "__VITE_ASSET__CWwXRtXY__"